<template>
  <div class="container">
    <div class="sign-page">
      <sign-header :headerConfig="headerConfig" @handleClickIocn="handleClickIocn" />
      <div class="sign-top">
        <div class="sign-title-wrap">
          <h2 class="sign-tit">请完善</h2>
          <p class="sub-tit">您的报名信息</p>
        </div>
      </div>
      <div class="main">
        <div class="sign-form">
          <sign-form  :form="form" :list="list" :btns="btns" :rules="rules" labelWidth="auto" labelPosition="top"
            ref="form" :loading = this.registerloading />
        </div>
      </div>
    </div>
    <!-- <ghdwmcSelectDialog
      :dialog="ghdwmcDialog"
      :item="localItem.ghdwmc"
      @selectghdwmc="onSelectghdwmc"
      @closeghdwmcSelectDialog="() => (ghdwmcDialog = false)"
    ></ghdwmcSelectDialog> -->
  </div>
</template>

<script>
  import ghdwmcSelectDialog from "./components/ghdwmcSelectDialog.vue";
  import signHeader from "@/components/header"
  import signForm from "@/components/form"
  import signSelect from "@/components/singleSelect"
  import multipleSelect from "@/components/multipleSelect"
  import { Signup } from "@/store/entity/signup"
  import { Invoice } from "@/store/entity/invoice"
  import merge from "lodash/merge"
  import { AttendIdentity } from "@/store/entity/attendidentity"
  import { Confsite } from "@/store/entity/confsite";
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import CurrentUserMixin from "@/mixin/CurrentUser"
  import radio from "@/components/radio";
  export default {
    name: "signUp",
    components: {
      signHeader,
      signForm,
      ghdwmcSelectDialog
    },
    mixins: [CurrentConferMixin, CurrentUserMixin],
    data() {
      return {
        registerloading:false,
        ghdwmcDialog: false,
        searchedKpCodeNameOptions: [],
        attendidList: [],
        attendidentity_list: [],
        attendidentityArr: [],
        confsiteOptions: [],
        conferenceArr: [],
        conference_list: [],
        requiredsites: [],
        requiredsiteids: [],
        headerConfig: {
          headerIcon: "city ct-cuowu",
          headerTitle: "中国土木工程学会",
          color: "#fff",
          bgColor: "#f9000d",
        },
        kpCodeNameOptions : [],
        ghdwmcLoading:false,
        gettaxresdata : null,
        isSeachKpxxDisabled : false,
        rules: {
          name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            {
              min: 2,
              max: 15,
              message: "长度在 2 到 15 个字符",
              trigger: "blur",
            },
          ],
          company: [
            { required: true, message: "请输入单位" },
            {
              min: 2,
              max: 30,
              message: "长度在 2 到 30 个字符",
              trigger: "blur",
            },
          ],
          job: [
            { required: true, message: "请输入职务" },
            {
              min: 2,
              max: 15,
              message: "长度在 2 到 15 个字符",
              trigger: "blur",
            },
          ],
          phone: [
            { required: true, message: "请输入电话" },
            {
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
              message: "请输入正确电话号码",
            },
          ],
          email: [
            { required: true, message: "请输入邮箱" },
            {
              pattern:
                // /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
                /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
              message: "请输入正确邮箱",
            },
          ],
          stu_code: [
            { required: true, message: "请输入学生证号" },
            {
              min: 2,
              max: 20,
              message: "长度在 2 到 20 个字符",
              trigger: "blur",
            },
          ],
          paper_code: [
            { required: true, message: "请输入论文编号" },
            {
              min: 2,
              max: 20,
              message: "长度在 2 到 20 个字符",
              trigger: "blur",
            },
          ],
          vip_code: [
            { required: true, message: "请输入工程会员编号" },
            {
              min: 2,
              max: 20,
              message: "长度在 2 到 20 个字符",
              trigger: "blur",
            },
          ],
          attendid_id: [{ required: true, message: "请选择参会身份" }],
          confsiteids: [{ required: true, message: "请选择会场" }],
          conference_id: [{ required: true, message: "请选择参加会议" }],
          pub_trans_name: [
            { required: true, message: "请输入对公转账人姓名" },
            {
              min: 2,
              max: 30,
              message: "长度在 2 到 30 个字符",
              trigger: "blur",
            },
          ],
          pub_trans_comp: [
            { required: true, message: "请输入对公转账人单位" },
            {
              min: 2,
              max: 30,
              message: "长度在 2 到 30 个字符",
              trigger: "blur",
            },
          ],
          pub_trans_phone: [
            { required: true, message: "请输入对公转账人手机号码" },
            {
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
              message: "请输入对公转账人手机号码",
            },
          ],
          title_type: [
            {
              required: true,
              message: "请选择发票抬头类型",
            },
          ],
          fplx: [
            {
              required: true,
              message: "请选择发票类型",
            },
          ],
          // ghsjh: [
          //   {
          //     required: true,
          //     message: "请输入购买方手机号",
          //     trigger: "blur",
          //   },
          //   {
          //     pattern:
          //       /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          //     message: "请输入正确购买方手机号",
          //   },
          // ],
          ghdwmc: [{ required: true, message: "请输入购买方名称" }],
          ghdzyx: [
            {
              required: true, message: "购买方电子邮箱"
            },
            {
              pattern:
                /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
              message: "请输入正确购买方电子邮箱",
            },
          ],
          ghnsrsbh: [{ required: true, message: "请输入购买方税号/身份证号" }],
        },
        remark: "",
        localItem: new Signup(),
      }
    },

    computed: {
      form: {
        get: function () {
          // 将store里查出来的报名记录放到localItem里，前提是localItem是初始空值
          // Object.keys(this.localItem).forEach((key) => {
          //   const value_of_local = this.localItem[key]
          //   const value_of_store = this.currentSignup[key]
          //   if (!value_of_local && value_of_store) {
          //     this.localItem[key] = value_of_store
          //   }
          // })
          //加代码原因，页面带出手机号后，手机号又清空了
          if (this.currentUser.username.length != 0) {
            this.localItem.phone = this.currentUser.username
            this.localItem.ghsjh = this.currentUser.username
            this.localItem.title_type = "单位票据"
            this.localItem.fplx = "数电普票"
          }
          return this.localItem
        },
        set(form) {
          this.localItem = form
          this.localItem.phone = this.$store.state.user.currentUser.username
        },
      },
      list() {
        let list = [
          {
            label: "姓名",
            prop: "name",
            render: "ElInput",
            disabled: false,
            attrs: {
              placeholder: "请输入姓名",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "单位",
            prop: "company",
            render: "ElInput",
            disabled: false,
            attrs: {
              placeholder: "请输入单位",
            },
            position: {
              span: 24,
            },
          },

          {
            label: "电话",
            prop: "phone",
            render: "ElInput",
            attrs: {
              placeholder: "请输入电话",
              readonly: true,
            },
            position: {
              span: 24,
            },
          },
          {
            label: "邮箱",
            prop: "email",
            render: "ElInput",
            disabled: false,
            attrs: {
              placeholder: "请输入邮箱",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "职务",
            prop: "job",
            render: "ElInput",
            disabled: false,
            attrs: {
              placeholder: "请输入职务",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "会场"+this.remark,
            prop: "confsiteids",
            render: multipleSelect,
            attrs: {
              options: this.confsiteOptions,
              labelField: "name",
              valueField: "id",
              disabledField:"disabled",
              clearable:false,//必须为false，不然会影响功能
              
            },
            listeners: {
              confsitechange: this.confsitechange,
              removeTag:this.removeTag
            },
            position: {
              span: 24,
            },
          },
          {
            label: "参会身份",
            prop: "attendid_id",
            render: signSelect,
            attrs: {
              placeholder: "请选择参会身份",
              options: this.attendidentityArr,
              labelField: "identity",
              valueField: "id",
            },
            position: {
              span: 24,
            },
          },
        ]
        //let is_student = this.form.attendid_id == 3;
        let attendValue = this.form.attendid_id
        let attendCode = this.getAttendCode(attendValue)
        if (attendCode == "A3") {
          //学生
          list.push({
            label: "学生证号",
            prop: "stu_code",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入学生证号" },
            position: { span: 24 },
          })
        } else if (attendCode == "A4") {
          //论文第一作者
          list.push({
            label: "论文编号",
            prop: "paper_code",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入论文编号" },
            position: { span: 24 },
          })
        } else if (attendCode == "A5") {
          //工程会员
          list.push({
            label: "工程会员编号",
            prop: "vip_code",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入工程会员编号" },
            position: { span: 24 },
          })
        } else if (attendCode == "A6") {
          //其他
          list.push({
            label: "对公转账人姓名",
            prop: "pub_trans_name",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入对公转账人姓名" },
            position: { span: 24 },
          });
          list.push({
            label: "对公转账人单位",
            prop: "pub_trans_comp",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入对公转账人单位" },
            position: { span: 24 },
          });
          list.push({
            label: "对公转账人手机号码",
            prop: "pub_trans_phone",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入对公转账人手机号码" },
            position: { span: 24 },
          });
          list.push({
            label: "备注",
            prop: "note",
            render: "ElInput",
            disabled: false,
            attrs: { placeholder: "请输入备注信息" },
            position: { span: 24 },
          })
        }
        let invoice_pre_list = [
          {
            label: "发票抬头类型",
            prop: "title_type",
            render: radio,
            attrs: {
              options:["单位票据","个人票据"],
            },
            position: {
              span: 24,
            },
            listeners: {
                //typechange: this.typechange
            },
          },
          {
            label: "发票类型",
            prop: "fplx",
            render: radio,
            attrs: {
              options:["数电普票","数电专票"],
            },
            position: {
              span: 24,
            },
          },
          {
          label: "发票购买方名称",
          prop: "ghdwmc",
          render: "ElAutocomplete",
          attrs: {
            placeholder: "请输入发票购买方名称",
            "value-key": "nsrmc",
            "debounce": 200,
            "size": "medium",
            "fetch-suggestions":  this.querySearchFapiaoInfoAsync,
            style: 'width:100%;'
          },
          position: {
            span: 24,
          },
          listeners: {
            select: this.handleSearchFapiaoSelect
          },
        },
          {
            label: "发票购买方税号/身份证号：单位票据填写税号，个人票据填写身份证号",
            prop: "ghnsrsbh",
            render: "ElInput",
            attrs: {
              placeholder: "请输入购买方税号/身份证号",
            },
            position: {
              span: 24,
            },
          },
          {
          label: "销售方银行账号是否显示",
          prop: "sfzsxsfyhzh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
          listeners: {},
        },
        {
          label: "销售方地址电话是否显示",
          prop: "sfzsxsfdzdh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
        },
        {
          label: "购买方银行账号是否显示",
          prop: "sfzsgmfyhzh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
          listeners: {},
        },
        {
          label: "购买方地址电话是否显示",
          prop: "sfzsgmfdzdh",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
        },
          {
            label: "发票购买方地址",
            prop: "ghdz",
            render: "ElInput",
            attrs: {
              placeholder: "请输入购买方地址",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "发票购买方电话",
            prop: "ghdh",
            render: "ElInput",
            attrs: {
              placeholder: "请输入购买方电话",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "发票购买方银行名称",
            prop: "ghyh",
            render: "ElInput",
            attrs: {
              placeholder: "请输入购买方银行名称",
            },
            position: {
              span: 24,
            },
          },
          {
            label: "发票购买方银行账号",
            prop: "ghzh",
            render: "ElInput",
            attrs: {
              placeholder: "请输入购买方银行账号",
            },
            position: {
              span: 24,
            },
          },
        ];
        list.push(...invoice_pre_list);
        return list
      },

      btns() {
        let d1 =new Date().getTime()
        let d2 = new Date(this.currentConference.signupdeadline).getTime()
        let d3 = new Date(this.currentConference.signupstart).getTime()
        let arr = new Array()
        if(this.currentConference.signupstart!=null && d1<d3){
          arr.push(
            {
              label: "本次会议报名未开始。",
              attrs: {
                style: `
                width: 100%; 
                `,
              },
            },
            
            )
            
          }
        if(this.currentConference.signupdeadline!=null && d1>=d2){
          arr.push(
            {
              label: "参会人数已满，欢迎您在线观看会议直播。",
              attrs: {
                style: `
                width: 100%; 
                `,
              },
            },
            
            )
            
          }
          if(this.currentConference.signupstart!=null && d1>=d3 && this.currentConference.signupdeadline!=null && d1<d2){
            arr.push(
              {
                label: "点击提交",
                disabled: true,
                attrs: {
                  style: `
                              width: 100%; 
                            `,
                },
                listeners: {
                  click: this.handleFormSubmit,
                },
              },
          )
        }
        return arr        
      }
    },

    async created() {
      this.getAttendIdentityList();
      await this.getConfSiteOptions();
      this.setRequiredSites();
      this.getConsiteRemark(this.confsiteOptions);
    },
    mounted() { },
    watch: {
    currentSignup: {
      handler(val) {
        if (val && val.id !== 0) {
          this.localItem = merge(new Signup(), val);
        }
      },
      deep: true,
    },
    currentConference: {
      handler(val) {
        if (val && val.id !== 0) {
          this.getConfSiteOptions();
        }
      },
      deep: true,
    },
    'localItem.email':{
      handler(val){
        this.localItem.ghdzyx = val;
      },deep:true
    },
    'localItem.title_type':{
      handler(val){
        if(val=="单位票据"){
          this.rules.ghnsrsbh[0].required = true;
          this.isSeachKpxxDisabled = false;
        }else{
          this.rules.ghnsrsbh[0].required = false;
          this.isSeachKpxxDisabled = true;
        }
        //清除表单中所有输入字段的校验状态
        this.$refs.form.clearValidate();
      },deep:true
    }
  },
    methods: {
    async querySearchFapiaoInfoAsync(queryString, cb) {
      if(queryString.length<4){
        // 小于4不搜索
        return cb([])
      }
      const tax_query_res = await Invoice.getTaxno(queryString);
      let gettaxresdata = []
      if(tax_query_res.code==="0000"){
        tax_query_res.msg.forEach(x=>{
          if(x.nsrmc.trimStart()==x.nsrmc && x.nsrmc.trimEnd()==x.nsrmc){
            if(x.nsrmc=="北京城建设计发展集团股份有限公司"){
              x.nsrsbh="91110000101360785M";
            }
            gettaxresdata.push(x)
          }
        })
        //gettaxresdata = tax_query_res.msg
      }
      return cb(gettaxresdata)
    },
    handleSearchFapiaoSelect(item){
      this.localItem.ghdwmc = item.nsrmc;
      this.localItem.ghnsrsbh = item.nsrsbh;
      this.localItem.ghdz = item.dz;
      this.localItem.ghdh = item.lxdh;
      this.localItem.ghyh = item.khhmc;
      this.localItem.ghzh = item.yhzh;
    },

    async remoteMethod(val){
      this.ghdwmcLoading = true
      this.gettaxresdata = await Invoice.getTaxno(val);
      this.ghdwmcLoading = false
      if(this.gettaxresdata.code=="0000"){
        this.kpCodeNameOptions = this.gettaxresdata.msg.map(item=>{
          return {kpCode:item.kpCode,kpName:item.kpName}
        })
      }
    },
      getOptionByid(val){
        let options = this.confsiteOptions.filter(item=>{
          if(item.id==val){
            return item
          }
        })
        return options[0]
      },
      removeTag(val){
        if(this.requiredsiteids.includes(val)){
          let defaultIndex = this.requiredsiteids.indexOf(val) // 获取默认值在数组中的下标
          this.localItem.confsiteids.splice(defaultIndex, 0, val) // 将要删除的值插入到默认值对应的下标位置
          this.localItem.confsites.splice(defaultIndex, 0, this.getOptionByid(val)) // 将要删除的值插入到默认值对应的下标位置
        }
      },
      setRequiredSites(){
        this.requiredsites.forEach(item=>{
            if(this.localItem.confsiteids.indexOf(item.id)<0){
              this.localItem.confsiteids.push(item.id);
              this.localItem.confsites.push(item);
            }
        })
      },
      async getConfSiteOptions() {
        if(this.currentConference.id && this.currentConference.id>0){
          await Confsite.getList({
            conference_id:this.currentConference.id,
            per_page: -1,
            page: -1,
          }).then((data) => {
            this.confsiteOptions = data.result.sort((a,b)=>a.order<b.order?-1:1)
            this.confsiteOptions.forEach((item)=>{
              if(item.fulled=="是"){
                item.name +="(已满)"; 
                item.disabled = true 
              }
              if(item.isrequired){
                item.disabled = true
              }
            })
            //过滤出是必选项的
            this.requiredsites = this.confsiteOptions.filter(item => {
              if(item.isrequired == true){
                this.requiredsiteids.push(item.id);
                return item
              }
            })
          });
        }
      },
      getConsiteRemark(confsiteOptions) {
        let requireditemname="";
        confsiteOptions.forEach(item=>{
          if(item.isrequired){
            requireditemname+=item.name+"、"
          }
        })
        requireditemname = requireditemname.substring(0,requireditemname.length-1);
        this.remark = "：同一时间举行的多个分论坛只能选择其中之一；"
        if(requireditemname.length>0){
          this.remark += requireditemname+"为必选项"
        }
      },
      arrayGroup(arr) {
        var str = {};
        var newArr = [];
        for (var i = 0; i < arr.length; i++) {
          var obj = arr[i];
          if (!str[obj.flag]) {
            newArr.push({
              flag: obj.flag,
              children: [obj]
            })
            str[obj.flag] = obj;
          } else {
            for (var j = 0; j < newArr.length; j++) {
              var newobj = newArr[j];
              if (newobj.flag === obj.flag) {
                newobj.children.push(obj);
                break;
              }
            }
          }
        }
        return newArr;
      },
      confsitechange(val) {
        //选中的数据对象
        let selectedsites = [];
        this.localItem.confsites = [];
        this.localItem.confsiteids = [];
        for (const selectedval of val) {
          for (const site of this.confsiteOptions) {
            if (selectedval == site.id) {
              selectedsites.push(site);
            }
          }
        }
        let groupedsites = this.arrayGroup(selectedsites);
        for (const groupedsite of groupedsites) {
          if (groupedsite.children.length == 1) {
            this.localItem.confsiteids.push(groupedsite.children[0].id);
            this.localItem.confsites.push(groupedsite.children[0]);
          } else {
            this.localItem.confsiteids.push(groupedsite.children[groupedsite.children.length-1].id)
            this.localItem.confsites.push(groupedsite.children[groupedsite.children.length-1])
          }
        }

      },
      getAttendCode(attendId) {
        for (const item of this.attendidentityArr) {
          if (item.id == attendId) {
            return item.code
          }
        }
      },
      handleClickIocn() {
        this.$router.go(-1)
      },
      /* 表单提交 */
      handleFormSubmit() {
        let attendValue = this.form.attendid_id
        let attendCode = this.getAttendCode(attendValue)
        if (!this.form.name || this.form.name.length > 15) {
          this.$message("输入姓名不能为空且不能多于15个字")
        } else if (!this.form.company || this.form.company.length > 30) {
          this.$message("输入单位不能为空且不能多于30个字")
        } else if (!this.form.job || this.form.job.length > 15) {
          this.$message("输入职务不能为空且不能多于15个字")
        } else if (!this.form.phone) {
          this.$message("请输入电话")
        } else if (!this.checkPhone(this.form.phone)) {
          this.$message("请正确输入手机号码")
        } else if (!this.form.email) {
          this.$message("请输入邮箱")
        } else if (!this.checkEmail(this.form.email)) {
          this.$message("请正确输入邮箱")
        } else if (
          attendCode == "A3" &&
          (!this.form.stu_code || this.form.stu_code.length > 20)
        ) {
          this.$message("学生证号不能为空且不能多于20个字")
        } else if (
          attendCode == "A4" &&
          (!this.form.paper_code || this.form.paper_code.length > 20)
        ) {
          this.$message("论文编号不能为空且不能多于20个字")
        } else if (
          attendCode == "A5" &&
          (!this.form.vip_code || this.form.vip_code.length > 20)
        ) {
          this.$message("工程会员编号不能为空且不能多于20个字")
        } else if (!this.form.attendid_id) {
          this.$message("请选择参会身份")
        } else if (this.form.confsiteids.length == 0) {
          this.$message("请选择会场")
        } else if (attendCode=="A6"&&(!this.form.pub_trans_name || this.form.pub_trans_name.length > 15)) {
          this.$message({message: "当参会身份为其他(对公转账)时对公转账人姓名不能为空且不能多于15个字",type: 'warning'});
        } else if (attendCode=="A6"&&(!this.form.pub_trans_comp || this.form.pub_trans_comp.length > 100)) {
          this.$message({message: "当参会身份为其他(对公转账)时对公转账人单位不能为空且不能多于100个字",type: 'warning'});
        } else if (attendCode=="A6"&&(!this.form.pub_trans_phone)) {
          this.$message({message: "当参会身份为其他(对公转账)时对公转账人手机号码不能为空",type: 'warning'});
        } else if (attendCode=="A6"&&!this.checkPhone(this.form.pub_trans_phone)) {
          this.$message({message: "请正确输入对公转账人手机号码",type: 'warning'});
        } else if (!this.form.title_type) {
          this.$message({
            message: "发票抬头类型为必选项",type: 'warning'
          });
        }else if (!this.form.fplx) {
          this.$message({
            message: "发票类型为必选项",type: 'warning'
          });
        }
        else if (!this.form.ghdwmc) {
          this.$message({
            message: "发票购买方名称为必填项",type: 'warning'
          });
        }  else if (!this.form.ghdzyx) {
          this.$message({
            message: "购买方电子邮箱为必填项",type: 'warning'
          });
        } else if (
          !/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
            this.form.ghdzyx
          )
        ) {
          this.$message({
            message: "请输入正确电子邮箱",type: 'warning'
          });
        } else if(this.localItem.title_type=="单位票据" && !this.localItem.ghnsrsbh){
          this.$message({
            message: "发票抬头类型为单位票据时，购买方税号为必填项",type: 'warning'
          });
        } else if (this.localItem.title_type=="单位票据" &&
          !/^[0-9A-HJ-NPQRTUWXY]{18}$/.test(
            this.localItem.ghnsrsbh
          ) && this.localItem.ghnsrsbh !== "88888888888888888888" && this.localItem.ghnsrsbh !== "610111768824461"
        ) {
          this.$message({
            message: "请输入正确购买方税号",type: 'warning'
          });
        } else if (this.localItem.title_type=="个人票据" && this.localItem.ghnsrsbh.trim().length>0 && !this.isValidIdCard(this.localItem.ghnsrsbh))
        {
          this.$message({
            message: "请输入正确购买方身份证号",type: 'warning'
          });
        } 
        else {
          this.registerloading = true;
          merge(this.localItem, this.form)
          // handle: () => {
          this.localItem.conference_id = this.currentConference.id
          // console.log("this.localItem.user_id");
          // console.log(this.currentUser.id);
          this.localItem.user_id = this.currentUser.id
          // console.log(this.localItem.user_id);
          this.localItem.status = "已完成"
          let attendCode = this.getAttendCode(this.localItem.attendid_id)
          if (attendCode == "A6" || attendCode == "A3" || attendCode == "A5") {
            this.localItem.status = "审核中"
          }
          this.localItem.createOrUpdateSignup().then((item) => {
            this.localItem = item
            // 报完名后可能状态发生改变，所以重新获取报名状态
            this.$store.dispatch("user/resetFetchSignupInfo")
            this.$router.push("/submitType")
            this.registerloading = false;
          })
          //}
        }
      },
      isValidIdCard(idCard) {  
        // 正则表达式，匹配 18 位身份证号  
        // 15 或 18 位，18位时最后一位可以为 X  
        const idCardReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;  
          
        // 校验身份证长度  
        if (idCard.length === 15 || idCard.length === 18) {  
            // 使用正则表达式校验  
            if (idCardReg.test(idCard)) {  
                // 校验通过，进行进一步校验（可选，如校验生日、地区码等）  
                // 这里只是简单的校验，没有进行复杂的逻辑校验  
                return true;  
            }  
        }  
          
        // 如果不满足以上条件，则返回 false  
        return false;  
    } ,
      checkEmail(email) {
        var reg =
          /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
        if (!reg.test(email)) {
          return false
        }
        return true
      },
      checkPhone(phone) {
        var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
        if (!reg.test(phone)) {
          return false
        }
        return true
      },
      getAttendIdentityList() {
        let ids = {}
        ids = AttendIdentity.getAttendIdentityList({
          per_page: -1,
          page: -1,
          order_by: 'order'
        }).then((data) => {
          data.attendidentity_list.forEach((x) => {
            if (x.code != "A7") {
              this.attendidentityArr.push({
                id: x.id,
                identity: x.name,
                code: x.code,
              })
            }
          })
          //this.rules["name"][0]["required"] = false;
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sign-top {
    width: 100%;
    color: #fff;
    padding: 40px 30px 90px;
    background: #ff2f28;
    box-sizing: border-box;
    border-bottom-left-radius: 25%;
    border-bottom-right-radius: 25%;

    .sign-title-wrap {
      position: relative;
      padding-bottom: 25px;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 5px;
        background: #fff;
      }
    }

    .sign-tit {
      font-size: 36px;
      font-weight: bold;
    }

    .sub-tit {
      font-weight: normal;
      margin-top: 15px;
      font-size: 26px;
    }
  }

  .main {
    position: relative;
    margin: 0 30px 30px;

    .sign-form {
      position: absolute;
      top: -55px;
      left: 0;
      right: 0;
      margin: 0 auto;
      padding-top: 15px;
      box-sizing: border-box;
      box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      background: #fff;

      .el-form {
        margin-top: 15px;

        ::v-deep .el-col {
          padding: 0 15px;
        }

        ::v-deep .el-form-item {
          margin-bottom: 30px;
        }

        ::v-deep .el-form-item__label {
          color: var(--main-color);
          line-height: 1;
          display: inline;
        }

        ::v-deep .el-input__inner {
          border: none;
          border-bottom: 1px solid #ccc;
          background: transparent;
        }

        ::v-deep .el-button {
          color: var(--main-color);

          &:hover {
            color: var(--main-color);
          }

          &:focus {
            color: var(--main-color);
            border-color: #fff;
          }
        }

        ::v-deep .el-select {
          width: 100%;
        }

        ::v-deep .submits {
          position: absolute;
          padding: 0 0 30px;
          bottom: -100px;

          .el-button {
            width: 90vh;
            border: none;
            background: var(--main-color);
            color: #fff;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
// 注意：不要加 scoped
// ElAutocomplete 下拉框换行样式
.el-autocomplete-suggestion__list li {
  white-space: normal !important;
  word-break: break-all !important;
  padding: 10px 15px !important;
  height: auto !important;
  line-height: 1.1 !important;
  min-height: 10px !important;
}

.el-autocomplete-suggestion__wrap {
  max-height: 400px !important;
}
</style>